import { React, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {getFormattedDate,isEndDateGreater,addMonthsToDateString,changeDateFormat,getMonthRange} from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { API_URL } from '../../../../Constant';
import messages from '../../../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import  {wholeSalePriceGroupWiseReport}  from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import priceTitle from '../../../../price.json';

function WholeSalePriceGroupWiseReport() {
    const token = useContext(MyContextProvider).token;
    const decode_token = jwtDecode(token);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState('');
    const storedLanguage = localStorage.getItem('language');
    const today = new Date();
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

 
  
// Handle on change Event ********
const handleDropdownChange = (e) => {
     setStartDate(e);
     const currentDate=getFormattedDate(e)
     let stringData=addMonthsToDateString(currentDate,5);
     let date= stringData[0] + stringData.slice(1).toLocaleLowerCase()
     setEndDate(date);
  };


 //handle excel sheet ***************
const handleGenerateExcel = async() => {

        if (!startDate || !endDate) {
            toast.error('Please select the date range', messages.COLOR_RED);
            return;
        }

        if(!isEndDateGreater(startDate,endDate)){
        toast.error(messages.DATE_BETWEEN_MESSAGE, messages.COLOR_RED);
        return;
        }

        let sDate= getFormattedDate(startDate);
        let eDate=  endDate[0] + endDate.slice(1).toLocaleUpperCase();

    try {
    showLoading(true);

        let post_data={
            fromDate: sDate,
            toDate:eDate,
         
        }
       
        const response = await axios.post(`${API_URL}api/price/WholeSalePriceIndex`, post_data, config);
        const reportData = response.data;


        if (reportData.status) {
            const firstHalf = [];
            const lastHalf =[];
          
        //    ***************** selected_half_year********************* 
            reportData.data.GroupCodes.selected_half_year.forEach(group => {
                // Add group data
                firstHalf.push({
                    serial: group.serial,
                    name: group.majorGroupName,
                    percentage: group.majorGroupTotalPercentage,
                    M1: group.M1,
                    M2: group.M2,
                    M3: group.M3,
                    M4: group.M4,
                    M5: group.M5,
                    M6: group.M6
                });
          
                group.subgroupsdata.forEach(subGroup => {
                  // Add subgroupsdata data
                  firstHalf.push({
                    serial: subGroup.serial,
                    name: subGroup.subMajorGroupName,
                    percentage: subGroup.subMajorGroupTotalPercentage,
                    M1: subGroup.M1,
                    M2: subGroup.M2,
                    M3: subGroup.M3,
                    M4: subGroup.M4,
                    M5: subGroup.M5,
                    M6: subGroup.M6
                   });
          
                  subGroup.majorItems.forEach(majorGroup => {
                    // Add major Items data
                    if (majorGroup.majorItemName !==''){
                    firstHalf.push({
                        serial: majorGroup.serial,
                        name: majorGroup.majorItemName,
                        percentage: majorGroup.majorGroupTotalPercentage,
                        M1: majorGroup.M1,
                        M2: majorGroup.M2,
                        M3: majorGroup.M3,
                        M4: majorGroup.M4,
                        M5: majorGroup.M5,
                        M6: majorGroup.M6
                    });
                  
                    }
                        majorGroup.subItems.forEach(subItems => {
                            // Add major Items data
                            if (subItems.subMajorItemName !==''){
                            firstHalf.push({
                                serial: subItems.serial,
                                name: subItems.subMajorItemName,
                                percentage: subItems.majorGroupTotalPercentage,
                                M1: subItems.M1,
                                M2: subItems.M2,
                                M3: subItems.M3,
                                M4: subItems.M4,
                                M5: subItems.M5,
                                M6: subItems.M6
                            });
                        }
                        
                          });
                    });
  
                  
                });
              });


        //    ***************** last_half_year********************* 
              reportData.data.GroupCodes.last_half_year.forEach(group => {
                // Add group data
                lastHalf.push({
                    serial: group.serial,
                    name: group.majorGroupName,
                    percentage: group.majorGroupTotalPercentage,
                    M1: group.M1,
                    M2: group.M2,
                    M3: group.M3,
                    M4: group.M4,
                    M5: group.M5,
                    M6: group.M6
                });
          
                group.subgroupsdata.forEach(subGroup => {
                  // Add subgroupsdata data
                  lastHalf.push({
                    serial: subGroup.serial,
                    name: subGroup.subMajorGroupName,
                    percentage: subGroup.subMajorGroupTotalPercentage,
                    M1: subGroup.M1,
                    M2: subGroup.M2,
                    M3: subGroup.M3,
                    M4: subGroup.M4,
                    M5: subGroup.M5,
                    M6: subGroup.M6
                   });
          
                  subGroup.majorItems.forEach(majorGroup => {
                    // Add major Items data
                    if (majorGroup.majorItemName !==''){
                    lastHalf.push({
                        serial: majorGroup.serial,
                        name: majorGroup.majorItemName,
                        percentage: majorGroup.majorGroupTotalPercentage,
                        M1: majorGroup.M1,
                        M2: majorGroup.M2,
                        M3: majorGroup.M3,
                        M4: majorGroup.M4,
                        M5: majorGroup.M5,
                        M6: majorGroup.M6
                    });
                }
                
                        majorGroup.subItems.forEach(subItems => {
                            // Add major Items data
                            if (subItems.subMajorItemName !==''){
                            lastHalf.push({
                                serial: subItems.serial,
                                name: subItems.subMajorItemName,
                                percentage: subItems.majorGroupTotalPercentage,
                                M1: subItems.M1,
                                M2: subItems.M2,
                                M3: subItems.M3,
                                M4: subItems.M4,
                                M5: subItems.M5,
                                M6: subItems.M6
                            });
                        }
                        
                          });
                    });
  
                  
                });
              });

              downloadReport(firstHalf,lastHalf,sDate,eDate)
          } else {
             toast.error('Data is not found', messages.COLOR_RED);
         }

    } catch (error) {
    console.error(error);

    }finally{
    showLoading(false);
    }
   }



 const formatGrossValue = (value,tofixed) => {
    if (value === 0) return "0.00";
    if (value === "NaN" ) return '';
    if (value === '' || value === null) return "0.00";
    return Number(value).toFixed(tofixed);
};


//Get sheet year
const headerSheetYear=(sDate,eDate,sheetType)=>{
      let year=[];
      if(sheetType==="Sheet1"){
          year=getMonthRange(sDate,5);
    }
    
    if(sheetType==="Sheet2"){
        year=getMonthRange(addMonthsToDateString(eDate,1),5)
    }
    
    const formattedDates = year.map((yearMonth)=>{
            const parts = yearMonth.split(' ');
             let month=parts[0].charAt(0).toUpperCase() + parts[0].slice(1).toLowerCase();
             let year=parts[1].toString().slice(-2);
             return (sheetType==="Sheet1") ? `${month}-${year}` :`${month}-${parseInt(year)-1}`
      })

    return formattedDates;
 }


   const downloadReport=(firstHalf,lastHalf,sDate,eDate)=>{



  
    const selected_half_year_data = firstHalf.map((item,index) => ([
        item.serial,
        item.name,
        formatGrossValue(item.percentage,4),
        formatGrossValue(item.M1,2),
        formatGrossValue(item.M2,2),
        formatGrossValue(item.M3,2),
        formatGrossValue(item.M4,2),
        formatGrossValue(item.M5,2),
        formatGrossValue(item.M6,2),
   ]));
   
  
    const selected_last_half_year_data = lastHalf.map((item,index) => ([
        item.serial,
        item.name,
        formatGrossValue(item.percentage,4),
        formatGrossValue(item.M1,2),
        formatGrossValue(item.M2,2),
        formatGrossValue(item.M3,2),
        formatGrossValue(item.M4,2),
        formatGrossValue(item.M5,2),
        formatGrossValue(item.M6,2),
   ]));
   
 
     const excelObjectData = {
         fileType: 'xls',
         firstRowMergeCells: "A1:I1",
         firstRowExportDate: changeDateFormat(new Date()),
         secondRowMergeCells: "A2:I2",
         secondRowText: `सारीणी -1 (ग) उत्तर प्रदेश के थोक भाव सूचकांक वर्गवार (आधार वर्ष  2011-12=100)`,
         thirdRowMergeCells: "A3:I3",
         thirdRowText: `Table-1 (c) Whole sale price index Numbers of U.P.- Group wise (Base Year 2011-12=100)`,
         headerBoldData:['PRIMARY ARTICLES','FUEL, POWER, LIGHT & LUBRICANTS',
            'MANUFACTURED PRODUCTS']
    
        };

       let year1= headerSheetYear(sDate,eDate,"Sheet1")
       let year2= headerSheetYear(sDate,eDate,"Sheet2")

     let selected_half_year={
        sheetName: "selected_half_year",
       ...excelObjectData,
       headerEnglishColumns:['S.NO.','Groups & Items','Percentage Weight',...year1],
       excelRowData: selected_half_year_data
     }

     let last_half_year={
        sheetName: "last_half_year",
        ...excelObjectData,
        headerEnglishColumns:['S.NO.','Groups & Items','Percentage Weight',...year2],
        excelRowData: selected_last_half_year_data
    }

     let finalObject={
        excelObjectData:[
            selected_half_year,
            last_half_year,
         
        ],
        fileName: `WPI_GroupWise_Report(${sDate.replace(/\s+/g, '_')}-${eDate.replace(/\s+/g, '_')}).xls`,
      
      }

     // extractedData[extractedData.length-1]=['Average',]
  
     wholeSalePriceGroupWiseReport(finalObject)
 
 
 }
  return (
    <>
    <ToastContainer />
    <GlobalLoading />
    <div className="container-fluid py-3">
        <div className="card mx-3 mb-3">
            <div className="card-body pb-1">
                <div className="row align-items-center">
                    <h4 className="page_heading">
                        <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.WHOLE_SALE_PRICE_GROUP_WISE_REPORT : priceTitle.en.WHOLE_SALE_PRICE_GROUP_WISE_REPORT }} />
                    </h4>
                    <div className="row align-items-center">
                        
                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                        <label className="fw-bold h6">From Date</label>
                        <DatePicker
                            className="form-control calendar_icon"
                            selected={startDate}
                            onChange={handleDropdownChange}
                            dateFormat="MMM yyyy"
                            showMonthYearPicker
                            placeholderText="Select month"
                            name="startDate"
                            maxDate={today}
                        />
                    </div>


                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                        <label className="fw-bold h6">To Date</label>

                        <input 
                        className="form-control"
                        type="text" 
                        name="endDate"
                        value={endDate}
                        readOnly
                        />
                    </div>


                    <div className="col-xl-2 col-lg-4 mb-3">
                        <label className="w-100 d-none d-sm-block">&nbsp;</label>
                        <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                    </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</>
  )
}

export default WholeSalePriceGroupWiseReport